module.exports = __webpack_public_path__ + "img/phone-about-us.7796ba9f.jpg";